// frontend/src/services/StuntService.js
import axios from 'axios';

class StuntService {
  getAllStunts(sessionId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunts`);
  }

  createStunt(sessionId, stunt) {
    return axios.post(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunts`, stunt);
  }

  updateStunt(sessionId, stuntId, stunt) {
    return axios.put(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunts/${stuntId}`, stunt);
  }

  deleteStunt(sessionId, stuntId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/stunts/${stuntId}`);
  }
}

export default new StuntService();
